import React from 'react';
import { Link } from 'react-router-dom';
import { FiArrowUpRight } from 'react-icons/fi';
import { servicesData } from '../Components/serviceMetaData';
import { caseStudies } from '../Data/websiteUpdates';
import { serviceSlug } from '../seo/publicSeo';
import { Process, ServiceEngagement } from './VoicesSolutions';
import { voicesSolutionsData } from './voicesSolutionsData';
import './voices-legacy-services.css';

// Supplied AntrazalGold.serviceDetails defaults, used only for the two
// Salesforce pages that include these sections in the shared preview.
export const legacyEngagement = {
  deliverables: [
    ['Business and data design', 'A shared view of the processes, data model, permissions and integrations in scope.'],
    ['A tested release', 'Configuration, automation, integration checks and acceptance scenarios agreed with the business.'],
    ['A usable handoff', 'Training, deployment notes and an agreed route for ongoing support and improvement.'],
  ],
  questions: [
    ['What should we prepare for discovery?', 'Bring the current workflow, the systems involved, a few representative exceptions, and the people who can approve the target process. Data quality and access constraints are important inputs.'],
    ['How do we judge the right implementation partner?', 'Ask for relevant work, a clear delivery scope, named responsibilities, test evidence, and a plan for operating the solution after launch. A slogan or a demo is not a substitute for those details.'],
    ['What happens after deployment?', 'Training, documentation and support responsibilities should be agreed before release. A managed engagement can add recurring evaluation, monitoring reviews and controlled improvements.'],
  ],
  relatedIntent: ['/services/ai-implementation', '/managed-agents', '/implementation-guide'],
};

const catalogue = [
  ...servicesData.filter(service => service.name?.trim()).map(service => ({ ...service, path: `/services/${serviceSlug(service.name)}` })),
  ...Object.values(voicesSolutionsData).filter(page => page.type === 'service'),
];

export function relatedLegacyServices(service) {
  const category = item => item.name === 'Azure' ? 'DevOps' : item.name === 'HubSpot Implementation' ? 'Marketing Automation' : item.category?.trim().replace(/^others?$/i, 'Others') || (item.name.startsWith('Salesforce ') ? 'Salesforce' : 'Others');
  let related = catalogue.filter(item => category(item) === category(service) && item.name !== service.name).slice(0, 3);
  if (related.length < 2) related = catalogue.filter(item => category(item) === 'Integration' && item.name !== service.name).slice(0, 3);
  return related;
}

export default function VoicesLegacyServiceSections({ service }) {
  const agentforce = service.name === 'Salesforce Agentforce';
  const detailed = agentforce || service.name === 'Salesforce Implementation';
  return <div className="vs-page vs-page--legacy" data-voices-theme="dark">
    {detailed && <ServiceEngagement page={legacyEngagement} />}
    <section className="vs-band vls-connections" aria-labelledby="vls-connections-title">
      <h2 className="vs-label" id="vls-connections-title">{agentforce ? 'Practical architecture' : 'Explore the connections'}</h2>
      <div className="vls-related-grid">
        {agentforce ? caseStudies.slice(0, 3).map(paper => <article className="vls-paper" key={paper.pdf}>
          <img src={paper.cover} alt={`${paper.title} white-paper cover`} width="600" height="800" loading="lazy" decoding="async" />
          <p className="vs-label">{paper.category}</p><h3>{paper.title}</h3><p>{paper.description}</p>
          <a className="vs-text-link" href={paper.pdf} target="_blank" rel="noopener noreferrer">Read white paper<FiArrowUpRight aria-hidden="true" /></a>
        </article>) : relatedLegacyServices(service).map(item => <article className="vls-paper" key={item.path}>
          <p className="vs-label">{item.category}</p><h3>{item.name}</h3><p>{item.headline}</p>
          <Link className="vs-text-link" to={item.path}>Explore the service<FiArrowUpRight aria-hidden="true" /></Link>
        </article>)}
      </div>
    </section>
    <Process />
  </div>;
}
